export function getApiErrorMessage(error, fallback = "Something went wrong.") {
  const detail = error?.response?.data?.detail;

  if (typeof detail === "string" && detail.trim()) return detail;

  if (Array.isArray(detail)) {
    const messages = detail
      .map(item => {
        if (typeof item === "string") return item;
        if (!item || typeof item !== "object") return "";
        const field = Array.isArray(item.loc) ? item.loc.filter(part => part !== "body").join(".") : "";
        return `${field ? `${field}: ` : ""}${item.msg || "Invalid value"}`;
      })
      .filter(Boolean);
    if (messages.length) return messages.join(" · ");
  }

  if (detail && typeof detail === "object") {
    return detail.msg || detail.message || fallback;
  }

  return error?.response?.data?.message || fallback;
}
